import React, {Component, Fragment} from 'react';

import {connect} from "react-redux";
import windowSize from "../libs/reactWindowSize";
import {withScenePosition} from "../scenePosition";

import {Link} from "react-router-dom";

class Highlight extends Component {

  constructor(props){
    super(props);
    this.state = {

    };
  }

  static getDerivedStateFromProps(props, state){
    let { clickable, tabIndex } = props;

    return {
      clickable: clickable || tabIndex !== undefined
    }
  }

  openTab(tabId, tabIndex){
    let { dispatch } = this.props;
    dispatch({
      type: "tab/ACTIVATE_TAB",
      payload: {
        id: tabId,
        index: tabIndex
      }
    })
  }

  render() {
    let { left, top, width, height, type, tabId, tabIndex, onMouseOver, onMouseOut, hover, filled } = this.props;
    const {clickable } = this.state;
    const {onClick, open, transparent, to } = this.props;

    switch(type){
      default:
      case "rectangle":
        return (

          <Fragment>

            {to !== undefined ?
              (
                <Link className={`highlight rectangle clickable  ${open ? "open" : ""} ${hover ? "hover" : ""} ${transparent ? "transparent" : ""}`}
                   to={{ pathname: to, search: window.location.search }}
                   style={{left: left, top: top, width: width, height: height}}
                   >
                </Link>) : (
                <div className={`highlight rectangle ${clickable ? "clickable" : ""} ${open ? "open" : ""} ${hover ? "hover" : ""}  ${transparent ? "transparent" : ""} ${filled ? "filled" : ""}`}
                   style={{left: left, top: top, width: width, height: height}}
                   onMouseOver={onMouseOver}
                   onMouseOut={onMouseOut}
                   onClick={tabIndex === undefined ? onClick : (e)=>this.openTab(tabId, tabIndex)}>
                </div>
              )
            }
          </Fragment>
        );
    }
  }
}

function mapStateToProps(state) {
  return {
    scene: state.scene,
    step: state.step
  }
}



export default windowSize(connect(mapStateToProps)(withScenePosition(Highlight)));



// WEBPACK FOOTER //
// ./src/components/Highlight.jsx